(() => {
 const root = document.getElementById('lrl-homepage');
 if (!root) return;
 root.querySelectorAll('[data-live-reviews]').forEach(button => button.addEventListener('click', () => {
  const native = document.querySelector('.jdgm-revs-tab-btn');
  if (native) { native.click(); const title=document.querySelector('.jdgm-revs-tab__title'); if(title) title.textContent='Real riders. Real reviews.'; const close=document.querySelector('.jdgm-revs-tab__main .jdgm-close-ico'); if(close){close.setAttribute('aria-label','Close rider reviews'); close.setAttribute('tabindex','0'); close.focus();} } else window.location.assign('/pages/reviews');
 }));
 const nativeSearch = root.querySelector('input[name="q"]');
 if (nativeSearch) {
  nativeSearch.addEventListener('focus', () => root.classList.add('lrl-search-active'));
  nativeSearch.addEventListener('blur', () => root.classList.remove('lrl-search-active'));
 }
 // Use the approved support rail while keeping the live app's review panel available.
 const syncNativeReviews = () => {
  const ready = Boolean(document.querySelector('.jdgm-revs-tab-btn'));
  if (ready) document.body.classList.add('lrl-native-reviews-ready');
  return ready;
 };
 const observe = new MutationObserver(() => {
  if (syncNativeReviews()) observe.disconnect();
 });
 if (!syncNativeReviews()) observe.observe(document.body,{childList:true,subtree:true});
 window.addEventListener('pagehide',()=>observe.disconnect(),{once:true});
})();
